import { useState } from "#app";
import dayjs from "dayjs";
import { h } from "vue";
import { result } from "lodash";

export const useFormatCurrency = (value: number, FixNumber: number = 0) => {
	return new Intl.NumberFormat("en", { minimumFractionDigits: FixNumber }).format(value);
	// let val = (value / 1).toFixed(FixNumber).replace('.', ',')
	// return preS + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
};
export const useRepLang = (langdata: string, replaceString: Array<string>) => {
	return langdata.replace(/\{([0-9]{0,})\}/g, (match, p, s, b) => {
		const t = replaceString[p] || "";
		return t;
	});
};
export const useTalentOrderBy = (method: string = "") => {
	const ListData: Array<OrderBy> = [
		{
			showname: useLangTran().salary + useLangTran().OrderByList.asc,
			name: "expectSalary",
			order: "asc",
		},
		{
			showname: useLangTran().salary + useLangTran().OrderByList.desc,
			name: "expectSalary",
			order: "desc",
		},
		{
			showname: useLangTran().jobyear + useLangTran().OrderByList.asc,
			name: "jobyear",
			order: "asc",
		},
		{
			showname: useLangTran().jobyear + useLangTran().OrderByList.desc,
			name: "jobyear",
			order: "desc",
		},
	];
	// if (method == "backstage") {
	//     ListData.push(<OrderBy>{
	//         showname: useLangTran().ApplyFor + useLangTran().lastUpdataTime + useLangTran().OrderByList.asc,
	//         name: "utcupdatatime",
	//         order: "asc"
	//     })
	//     ListData.push(<OrderBy>{
	//         showname: useLangTran().ApplyFor + useLangTran().lastUpdataTime + useLangTran().OrderByList.desc,
	//         name: "utcupdatatime",
	//         order: "desc"
	//     })
	// }
	return ListData;
};
export const useTourOrderBy = (method: string = "") => {
	const ListData: Array<OrderBy> = [
		{
			showname: useLangTran().CreateTime + useLangTran().OrderByList.newToOld,
			name: "issueDate",
			order: "desc",
		},
		{
			showname: useLangTran().StartDate + useLangTran().OrderByList.asc,
			name: "startDate",
			order: "asc",
		},
		{
			showname: useLangTran().StartDate + useLangTran().OrderByList.desc,
			name: "startDate",
			order: "desc",
		},
		{
			showname: useLangTran().lastUpdataTime + useLangTran().OrderByList.desc,
			name: "updatatime",
			order: "desc",
		},
	];
	if (method == "backstage") {
		ListData.push(<OrderBy>{
			showname: useLangTran().ApplyFor + useLangTran().lastUpdataTime + useLangTran().OrderByList.asc,
			name: "utcupdatatime",
			order: "asc",
		});
		ListData.push(<OrderBy>{
			showname: useLangTran().ApplyFor + useLangTran().lastUpdataTime + useLangTran().OrderByList.desc,
			name: "utcupdatatime",
			order: "desc",
		});
	}
	return ListData;
};
export const useLangList = () => {
	return [
		{
			name: "zh-tw",
			value: "zh-tw",
		},
		{
			name: "en",
			value: "en",
		},
	] as Array<ItemValue>;
};
export const useChangelang = (value, field) => {
	// let result = (store.state.Public.publang[field]) ? store.state.Public.publang[field][value] :"";
	const result = null;
	return result || value;
	// return ((store.state.publang[field])?store.state.publang[field][value]:"") || value;
};
export const usedayjs = (value: any, method: any, avg1: any = null, avg2: any = null, avg3: any = null) => {
	if (value == null) {
		return dayjs();
	}
	return dayjs(value)[method](avg1, avg2, avg3);
};
export const removeTA = (data: string) => {
	const text = data.replace("旅行社-", "");
	return text.replace("會員-", "");
};
export const useColorNull = (value: Array<any>, colorClass: Array<any>, addClass: Array<any>) => {
	let result = (colorClass ? (colorClass.length > 0 ? colorClass : "") : "") || addClass;
	if (value) {
		result = value.length > 0 ? value : result;
	}

	return result;
};
export const useTextMark = (text: string, mark: string, color: string = "warning") => {
	let check = new RegExp(mark, "ig");
	return text.toString().replace(check, (matchedText, a, b) => {
		// return h("span",[h("strong",{class:"text-"+color}),matchedText]);
		return '<strong class="bg-' + color + '">' + matchedText + "</strong>";
	});
};
export const useCopyText = (data: string) => {
	if (window.isSecureContext) {
		navigator.clipboard
			.writeText(data)
			.then(() => {
				alert("已複製" + data);
			})
			.catch(() => {
				alert("fail");
			});
	} else {
		const tmpTextField = document.createElement("textarea");
		tmpTextField.textContent = data;
		tmpTextField.setAttribute("style", "position:absolute; right:200%;");
		document.body.appendChild(tmpTextField);
		tmpTextField.select();
		tmpTextField.setSelectionRange(0, 99999); /*For mobile devices*/
		document.execCommand("copy");
		tmpTextField.remove();
		alert("已複製文字：" + data);
	}
};
export const useOpenCV = () => {
	const isOpenCVReady = ref(false);

	const checkcv = () => {
		// OpenCV 加載完成後會掛載到 window.cv
		if (window.cv && window.cv.Mat) {
			isOpenCVReady.value = true;
		} else {
			// 監聽 OpenCV 的 Module 初始化完成事件
			window.Module = {
				onRuntimeInitialized: () => {
					isOpenCVReady.value = true;
				},
			};
		}
	};

	onMounted(() => {
		checkcv();
	});

	return { isOpenCVReady };
};
export const  useMaskPhone = (phone:string) =>{
	if (!phone) return "";
	// 移除所有非數字字元（例如空格或 -）
	const cleanPhone = phone.replace(/\D/g, "");

	// 檢查是否為常見的 10 碼手機號碼
	if (cleanPhone.length === 10) {
		// 遮罩中間 4 碼： 0912***678
		return cleanPhone.replace(/(\d{4})(\d{3})(\d{3})/, "$1***$3");
		// 如果想遮 4 碼改成： cleanPhone.replace(/(\d{3})(\d{4})(\d{3})/, '$1****$3');
	}

	return phone; // 格式不符則原樣回傳
}
export const useMaskEmail = (email:string)=> {
	if (!email || !email.includes("@")) return email;

	const [name, domain] = email.split("@");

	if (name.length <= 2) {
		// 帳號太短時（如 ab@test.com），直接變 a*@test.com
		return name.substring(0, 1) + "*" + "@" + domain;
	}

	// 保留前 2 碼與最後 1 碼，中間依據長度補上星號
	const visibleFront = name.substring(0, 2);
	const visibleBack = name.substring(name.length - 1);
	const maskLength = name.length - 3;
	const mask = "*".repeat(maskLength > 0 ? maskLength : 3); // 最少補 3 個星號

	return `${visibleFront}${mask}${visibleBack}@${domain}`;
}
export default () => {
	return useState("foo", () => "bar");
};
